/**
 * Created by laszlo.czondor on 2017. 02. 27.
 *
 * This directive validates a datepicker date between given min (and max dates TODO)
 */

export default function (app) {
	app.directive('datepickerValidator', function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, element, attrs, controller) {
				function setValidityFromDays(ngModelValue) {
					if (attrs.fromDays) {
						var fromDays = Number(attrs.fromDays);

						if (fromDays > 0) {
							var modelDate = new Date(ngModelValue);

							// set date to the restricted date (at midnight)
							var fromDate = new Date();
							fromDate.setDate(fromDate.getDate() - fromDays);
							fromDate.setHours(0, 0, 0, 0);

							var fromDateIsBeforeModelDate = fromDate.getTime() <= modelDate.getTime();

							if (fromDateIsBeforeModelDate) {
								controller.$setValidity('datepickerValidatorFromDate', true);

								return ngModelValue;
							} else {
								controller.$setValidity('datepickerValidatorFromDate', false);
							}
						}
					}
				}

				controller.$parsers.push(setValidityFromDays);
			}
		};
	});
};
